import logo from './logo.svg';
import './App.css';
import { Box } from '@chakra-ui/react';
import Navbar from './componets/Navbar';
import Allroutes from './componets/Allroutes';

function App() {
  return (
    <Box>
   <Allroutes/>

    </Box>
  )
}

export default App;
